import React, { useEffect, useMemo, useState } from "react";
import { eventActions } from "../../../_actions";
import { withTranslation, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/Header/Header";
import ".././Dashboard.scss";
import SoldToManagmentTable from "../../../components/MaterialTable/SoldToManagmentTable";
import AuthorizedMessage from "../../../components/AuthorizedMessage";
import { isPermission } from "../../../_helpers/commonAPI";
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";


function SoldToManagment(props) {
  const event = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const MyNewClass = useSelector((state) => state.addclasswithstyle.addclasswithstyle);
  const [isUserAllow, setIsUserAllow] = useState(true)

  let userName = localStorage.getItem('userData');
  userName = JSON.parse(userName);

  useMemo(async()=>{
      const per =  await isPermission("SoldToManagement-MainPage-view")   
      setIsUserAllow(per)
  },[])


  return (
    <>
      <div className="content-wrapper">
        <Header title="Sold To Managment" />

        <div className={"row view_section ipad_css " + MyNewClass}>
          <div className="mainScroll">
            {isUserAllow ?

              <div className="col-12 mt-2 mrg-top">
                <div className="table-responsive table_design retaiter-table">
                  <SoldToManagmentTable />
                </div>
              </div>

              :
              <AuthorizedMessagePage />
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(SoldToManagment);
